class FormChecker {
    public id: string = '';
    public value: boolean = false;
    public message: string = 'You are required to fill up this field.';

    constructor(checkerList: FormChecker[], value: boolean, message: string) {
        this.id = this.GenerateID(checkerList);
        this.value = value;
        this.message = message;
    }
    
    //privates
    private GenerateID = (checkerList: FormChecker[]):any => {
        const id = this.GenerateAlphaNumeric();
        let idExisted = false;
        checkerList.map((checker: FormChecker) => {
            if(!idExisted && checker.id == id) {
                idExisted = true;
            }
        });

        if(!idExisted)
            return id;
        else
            return this.GenerateID(checkerList);
    }
    private GenerateAlphaNumeric = (length = 12) => {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        
        for (let i = 0; i < length; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        
        return result;
    }
}
export default FormChecker;